import React, {useEffect} from "react";

import {Countries} from "../../../../../Constants/Countries";
import FormsApi from "../../../../../Service/FormsApiService";
import {usePage} from "../../../../../Provider/PageProvider";

interface Props {
    val: string;
}

interface Country {
    name: string;
    code: string;
}

export default function CountryField({val}: Props) {
    const {onAddressChange} = usePage();

    const init = () => {
        FormsApi.init().then(res => {
            if (res.country) {
                const address = {
                    'country': res.country,
                    'city': res.city,
                    'state': res.state,
                }
                onAddressChange('multiple', JSON.stringify(address));
            }
        });
    }

    useEffect(init, []);

    return <p className={"focus"}>
        <label htmlFor="country">Country</label>
        <select value={val} onChange={(e) => onAddressChange('country', e.target.value)} id={"country"}>
            {Countries.map((item: Country) => {
                return (<option key={'country-' + item.code} value={item.code}>{item.name}</option>)
            })}
        </select>

    </p>
}
